/**
 * Constant to represent export gradebook state in UI
 */
const ExportState = {
  STALE: 'stale',
  UPDATED: 'updated',
  GENERATING: 'generating',
  ERROR: 'error',
};

export default ExportState;

export const { STALE, UPDATED, GENERATING, ERROR } = ExportState;
